import ReactPlayer from "react-player";
import useHomeworkState from "../state/homework.state";
import CueManager from "./CueManager";

type Props = {
  videoRef: ReactPlayer;
  hasCaptions: boolean;
  hasSubtitles: boolean;
  isDisabled?: boolean;
};

export default function SubtitleAndCaptionManager({
  videoRef,
  hasCaptions,
  hasSubtitles,
  isDisabled = false,
}: Props) {
  const { subtitles, setSubtitles, captions, setCaptions } = useHomeworkState();

  return (
    <CueManager
      cues={[...subtitles, ...captions]}
      setCues={(cueKind) =>
        cueKind === "captions" ? setCaptions : setSubtitles
      }
      kind={
        hasCaptions && hasSubtitles
          ? "captions_and_subtitles"
          : !hasCaptions && hasSubtitles
            ? "subtitles"
            : "captions"
      }
      videoRef={videoRef}
      isDisabled={isDisabled}
    />
  );
}
